export const RATING_FILTER_CODE = 'rating';
